import './style.scss';
import AppCommunitiesSearchResultRow from '../../components/app_communitiesSearchResultRow/AppCommunitiesSearchResultRow';
import { CommunitiesResultProfile } from '../../server/types';

function AppCommunitiesResultRows() {

	const communityProfiles: CommunitiesResultProfile[] = [
		{
			id: '1',
			name: 'Community Name',
			profile_pic: '/imgs/temp/community/temp-icon.png'
		},{
			id: '2',
			name: 'Skiing Community',
			profile_pic: '/imgs/temp/community/temp-comm_01.jpg'
		},{
			id: '3',
			name: 'Other Com',
			profile_pic: '/imgs/temp/community/temp-comm_02.png'
		},{
			id: '4',
			name: 'Example',
			profile_pic: '/imgs/temp/community/temp-comm_03.jpg'
		}
	]

	return (
		<div className='section-content section-content-removed-padding'>
			<AppCommunitiesSearchResultRow
				label='Community Type'
				profiles={communityProfiles}
			/>
			<AppCommunitiesSearchResultRow
				label='Community Type'
				profiles={communityProfiles}
			/>
			<AppCommunitiesSearchResultRow
				label='Community Type'
				profiles={communityProfiles}
			/>
		</div>
	)
}

export default AppCommunitiesResultRows
